<template>
  <b-modal id="modal-onboarding" title="Welcome!">
    <div class="intro">
      <img src="/logo-big-white.svg" class="logo img-fluid" />
      <h3>You're account is ready</h3>
      <div class="account">
        <div class="list-item">
          <check-icon size="1.25x"></check-icon>
          <span> {{ user.email }} is your account's email address </span>
        </div>
        <div class="list-item">
          <check-icon size="1.25x"></check-icon>
          <span> Realtime sync is enabled </span>
        </div>
        <div class="list-item">
          <check-icon size="1.25x"></check-icon>
          <span> Your account has been created </span>
        </div>
      </div>
      <h3 class="next">Next Steps</h3>
    </div>
    <ol class="fancy">
      <li>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <h3>Install the Chrome extension</h3>
              <a
                href="https://chrome.google.com/webstore/detail/underlineme-web-and-pdf-a/bfgkgjjcgcfdjdcdcicnekhhldinkkhk"
                target="_blank"
                class="btn download-button"
              >
                <img src="chrome-web-store-icon.png" />
                <h5>Download from the Chrome webstore.</h5>
              </a>
              <p>
                After installation, pin the extension to the taskbar for easier
                access.
              </p>
            </div>
            <div class="col-md-6">
              <img class="img-fluid" src="onboarding/1.gif" />
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-6">
              <h3>Take some annotations</h3>
              <p>
                Drag to select any text on any webpage to activate the
                highlighter. Use this to take annotations.
              </p>
              <p>
                You can also add a comment to a annotation by clicking on it.
              </p>
            </div>
            <div class="col-md-6">
              <img class="img-fluid" src="onboarding/2.gif" />
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <h3>View your annotations</h3>
              <p>Browse through your annotations through the dashboard.</p>
              <p>
                All your annotations will magically show up in the dashboard.
              </p>
            </div>
            <div class="col-md-12">
              <img class="img-fluid" src="onboarding/3.jpg" />
            </div>
          </div>
        </div>
      </li>
    </ol>
    <div class="intro">
      <p>
        That's all to it. Should you have any questions or feature requests, you
        can drop us a line at
        <a href="mailto:shash@underlineme.com" target="_blank"
          >shash@underlineme.com</a
        >
      </p>
      <b-button
        variant="secondary"
        @click="$bvModal.hide('modal-onboarding')"
        size="lg"
      >
        Finish
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { CheckIcon } from "vue-feather-icons";
export default {
  components: {
    CheckIcon,
  },
  data: function () {
    var obj = {
      tutorial: {
        slide: 0,
        sliding: null,
      },
    };
    return obj;
  },
  computed: {
    version: function () {
      return this.$store.getters.version;
    },
    user: function () {
      return this.$store.getters["user/user"];
    },
  },
  methods: {
    onSlideStart(slide) {
      this.tutorial.sliding = true;
    },
    onSlideEnd(slide) {
      this.tutorial.sliding = false;
    },
    checkout() {
      this.$store.dispatch("user/startCheckout").then((sessionId) => {
        this.sessionId = sessionId;
      });
    },
    onSubmit: function () {},
    onTourStart: function () {
      this.startTour();
    },
  },
  mounted: function () {},
};
</script>

<style lang="scss">
#modal-onboarding___BV_modal_outer_ {
  .modal-header,
  .modal-footer {
    display: none;
  }

  .modal-dialog {
    max-width: 720px;
  }

  .modal-content {
    border-radius: 12px;
    position: relative;

    .intro {
      padding: 2rem;
      text-align: center;

      .next {
        color: var(--p1);
        margin-top: 1rem;
        margin-bottom: -4rem;
      }
    }

    .account {
      display: inline-block;
      width: 420px;
      margin-top: 1rem;
      margin-bottom: 1rem;
      text-align: left;
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: 10px;
      padding: 1.5rem;
    }

    .list-item {
      margin-bottom: 0.5rem;

      &:last-child {
        margin-bottom: 0;
      }
      svg {
        margin-right: 4px;
        padding: 3px;
        background-color: var(--success);
        border-radius: 50%;
        stroke-width: 3px;
      }
    }

    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 12px;
      pointer-events: none;
      background: linear-gradient(
        350deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.06) 70%
      );
    }
    .download-button {
      margin-bottom: 1rem;
      display: flex;
      width: 100%;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.6);
      text-align: left;
      h5 {
        line-height: 1.4;
        margin: 0;
      }
      img {
        width: 48px;
        height: auto;
        margin-right: 1rem;
      }
    }
    .logo {
      max-width: 200px;
      margin-bottom: 1rem;
    }
    ol.fancy {
      li {
        margin-top: 6rem;
        margin-bottom: 6rem;

        &:before {
          color: var(--s2);
          border-color: var(--s2);
        }

        &:after {
          content: "";
          position: absolute;
          bottom: -3rem;
          left: calc(50% - 20px);
          width: 40px;
          height: 4px;
          border-radius: 2px;
          background-color: var(--s2);
        }

        img {
          border-radius: 5px;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
